import React, { useState } from 'react';
import Form from '../../../common/Form';
import { useForm } from 'react-hook-form';
import { closeModalAction } from '../../../actions/modal';
import { useDispatch, useSelector } from 'react-redux';
import { addDocketDetails } from '../../../actions/service_request';
import Courier from '../../../components/Inputs/Courier';
import Input from '../../../common/Form/Input';
import { convertIntoPaisa } from '../../../utils/utils';
import { actualValueForDropdown } from '../../../utils/common';
import RenderMilestones from '../components/RenderMileStones';

const formName = 'addDocketDetails';

export default function AddDocketDetails({ ticket }) {
    const { formButtonLoading } = useSelector((state) => state.loading);
    const defaultValues = {};
    const dispatch = useDispatch();
    const methods = useForm({ defaultValues, mode: 'all' });

    const [selectedMilestones, setSelectedMilestones] = useState();


    const submit = (formValues) => {
        const payload = {
            vendor_id: actualValueForDropdown(formValues.vendor_id),
            docket_number: formValues.docket_number,
            cost_in_paisa: convertIntoPaisa(formValues.cost_in_paisa) ? convertIntoPaisa(formValues.cost_in_paisa) : undefined,
        };
        dispatch(addDocketDetails({ ticketId: ticket.id, milestoneId: selectedMilestones, payload, formName }));
    };

    const isHandleHeldingSelected = actualValueForDropdown(methods.watch('vendor_id')) === 'HAND_HOLDING';

    const containerVariants = {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: {
                staggerChildren: 0.1,
                when: "beforeChildren"
            }
        }
    };

    return (
        <div className="px-4 py-4 relative overflow-hidden">
            <RenderMilestones milestones={ticket.milestones} selectedMilestones={selectedMilestones} setSelectedMilestones={setSelectedMilestones} agents={ticket.agents} />
            <Form
                onSubmit={submit}
                methods={methods}
                showSubmit
                submitContainerClassName='flex gap-3 justify-end py-4 px-6 bg-gray-50 border-t'
                isLoading={formButtonLoading[formName]}
                submitButtonText='Update'
                submitButtonClassName='text-white px-4 py-2 rounded-md transition-colors'
                cancelButtonClassName='border border-gray-300 bg-white hover:bg-gray-50 text-gray-700 px-4 py-2 rounded-md transition-colors'
                onCancel={() => dispatch(closeModalAction())}
            >

                <div className='grid grid-cols-3 gap-4'>

                    <Courier
                        name='vendor_id'
                        label='Courier Vendor'
                        required
                    />

                    {!isHandleHeldingSelected && (
                        <>

                            <Input
                                name='docket_number'
                                label='Docket Number'
                                required
                                placeholder="Enter tracking number"
                            />

                            <Input
                                name='cost_in_paisa'
                                label='Logistics Cost (₹)'
                                // required
                                type="number"
                                step="0.01"
                                placeholder="0.00"
                            />

                        </>
                    )}
                </div>
            </Form>
        </div>
    );
}
